export function erroPecasAvulsas(pecas: { tipoVeiculo?: string; etiqueta?: string; uf?: string; nome?: string }[]): string | null {
  const etiquetas = new Set<string>();
  for (const peca of pecas) {
    if (peca.tipoVeiculo !== "avulsa") continue;
    if (!peca.nome?.trim()) return "Informe o nome da peça especial.";
    if (!peca.uf || !/^[A-Z]{2}$/.test(peca.uf) ||
      !new RegExp(`^${peca.uf}5[0-9]{1,13}$`).test(peca.etiqueta ?? "")) {
      return "Informe o número da etiqueta avulsa com 1 a 13 dígitos para cada peça especial.";
    }
    if (etiquetas.has(peca.etiqueta!)) return "Não repita a etiqueta avulsa em duas peças especiais.";
    etiquetas.add(peca.etiqueta!);
  }
  return null;
}
